import { useState } from 'react';

export const useForm = (initialState, validators = {}) => {
  const [form, setForm] = useState(initialState);
  const [errors, setErrors] = useState({});

  const getNestedValue = (obj, path) => {
    return path.reduce((acc, key) => (acc && acc[key] !== undefined ? acc[key] : undefined), obj);
  };

  const setNestedError = (errorsObj, path, index, error) => {
    errorsObj.transformations[index] = errorsObj.transformations[index] || {};
    let nested = errorsObj.transformations[index];
    for (let i = 0; i < path.length - 1; i++) {
      const part = path[i];
      nested[part] = nested[part] || {};
      nested = nested[part];
    }
    nested[path[path.length - 1]] = error;
  };

  const validateForm = () => {
    const newErrors = {};
    let isValid = true;

    newErrors.transformations = [];

    Object.keys(validators).forEach((key) => {
      if (key.startsWith('transformations.')) {
        const path = key.split('.').slice(1); // Skip "transformations"
        const validator = validators[key];

        form.transformations.forEach((transform, index) => {
          const value = getNestedValue(transform, path);
          let error = '';

          if (validator.required && (!value || (Array.isArray(value) && value.length === 0))) {
            error = 'This field is required';
          }

          if (!error && validator.pattern && !validator.pattern.test(value)) {
            error = validator.message || 'Invalid format';
          }

          if (!error && typeof validator.validate === 'function') {
            error = validator.validate(value, transform, form, index) || '';
          }

          if (error) {
            isValid = false;
            setNestedError(newErrors, path, index, error);
          }
        });
      } else {
        const error = validateField(key, form[key], form);
        if (error) {
          isValid = false;
          newErrors[key] = error;
        }
      }
    });

    setErrors(newErrors);
    return isValid;
  };

  const validateField = (name, value, fullForm = form) => {
    if (!validators[name]) return '';
    const validator = validators[name];

    if (validator.required && (!value || (Array.isArray(value) && value.length === 0))) {
      return 'This field is required';
    }

    if (validator.pattern && !validator.pattern.test(value)) {
      return validator.message || 'Invalid format';
    }

    if (typeof validator.validate === 'function') {
      return validator.validate(value, fullForm) || '';
    }

    return '';
  };

  const setFieldValue = (name, value) => {
    setForm((prev) => {
      if (name.includes('.')) {
        const keys = name.split('.');
        if (keys[0] === 'transformations') {
          const [, indexStr, ...rest] = keys;
          const index = parseInt(indexStr, 10);
          const updatedTransforms = [...prev.transformations];
          let target = updatedTransforms[index];

          for (let i = 0; i < rest.length - 1; i++) {
            const key = rest[i];
            target[key] = target[key] || {};
            target = target[key];
          }
          target[rest[rest.length - 1]] = value;

          return {
            ...prev,
            transformations: updatedTransforms,
          };
        }
      }

      return { ...prev, [name]: value };
    });
  };

  return {
    form,
    errors,
    setForm,
    setFieldValue,
    validateForm,
    handleChange: (e) => {
      const { name, value, type, checked } = e.target;
      setFieldValue(name, type === 'checkbox' ? checked : value);
    },
  };
};
